import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: { user: null, token: null, isLoggedIn: false, role:null },
  reducers: {
    setCredentials: (state, action) => {
      const actionData = action.payload;
      const { email, token, type } = actionData.data;
      state.user = email;
      state.role = type;
      state.token = token;
      state.isLoggedIn = true;
    },
    logout: (state, action) => {
      state.user = null;
      state.role = null;
      state.token = null;
      state.isLoggedIn = false;
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentUserRole = (state) => state.auth.role;
export const selectCurrentToken = (state) => state.auth.token;
export const selectIsLogged = (state) => state.auth.isLoggedIn;
